import React from 'react';
import { Layout } from '../Layout';
import Table from '@cloudscape-design/components/table';
import Header from '@cloudscape-design/components/header';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getApiHeader } from 'src/utils';

interface LeaderBoardData {
    EventAgeGrade: string;
    EventCategoryName: string;
    EventName: string;
    FirstPlaceParticipant: string;
    SecondPlaceParticipant: string;
    ThirdPlaceParticipant: string;
}

export const Leaderboard: React.FC = () => {
    const headers = getApiHeader();

    const { data: leaderBoardList, isPending } = useQuery<LeaderBoardData[]>({
        queryKey: ['leaderboard'],
        queryFn: async () => {
            const result = await axios.get('https://5aj7d2i2vi.execute-api.us-east-1.amazonaws.com/Prod/getLeaderboardForAllEvents', {
                headers
            });
            return result.data.result;
        },
    });

    return (
        <Layout breadcrumbs={[
            {
                href: '/leaderboard',
                text: 'Leaderboard'
            }
        ]}>
            <Table
                columnDefinitions={[
                    {
                        id: "eventName",
                        header: "Event Name",
                        cell: item => item.EventName || "-",
                    },
                    {
                        id: "eventAgeGrade",
                        header: "Event Age Grade",
                        cell: item => item.EventAgeGrade || "-"
                    },
                    {
                        id: "firstPlaceParticipant",
                        header: "First Place",
                        cell: item => item.FirstPlaceParticipant || "-"
                    },
                    {
                        id: "secondPlaceParticipant",
                        header: "Second Place",
                        cell: item => item.SecondPlaceParticipant || "-"
                    },
                    {
                        id: "thirdPlaceParticipant",
                        header: "Third Place",
                        cell: item => item.ThirdPlaceParticipant || "-"
                    },
                ]}
                items={leaderBoardList ?? []}
                loading={isPending}
                loadingText="Loading leaderboard"
                sortingDisabled
                header={<Header> Leaderboard </Header>}
            />
        </Layout>
    )
}